<template>
    <div class="location-nav" :style="[scrollLockStyles]">
        <div class="location-nav--wrap">
            <transition name="trs-location-nav-toggle">
                <div v-if="showLocationNav" class="location-nav--bar">
                    <button class="u-reset location-nav--prev"
                            :disabled="prevLoc.location_name ? null : true"
                            @click.prevent="onLocationRequested(prevLoc.link)">
                        <div class="location-nav--btn-wrap location-nav--btn-wrap__prev">
                            <cmp-ink-ripple class="location-nav--ripple btn--ink-ripple"></cmp-ink-ripple>
                            <div class="location-nav--icon-wrap">
                                <cmp-icon symbol="arrow-up" size="small" class="location-nav--icon"></cmp-icon>
                            </div>
                        </div>
                    </button>
                    <button class="u-reset location-nav--next"
                            :disabled="nextLoc.location_name ? null : true"
                            @click.prevent="onLocationRequested(nextLoc.link)">
                        <div class="location-nav--btn-wrap location-nav--btn-wrap__next">
                            <cmp-ink-ripple class="location-nav--ripple btn--ink-ripple"></cmp-ink-ripple>

                            <span class="location-nav--description">
                                <span class="location-nav--title"
                                        v-if="nextLoc.location_name"
                                        v-text="nextLoc.title">
                                </span>
                                <span class="u-reset u-reset__h2 location-nav--loc-name"
                                        v-if="nextLoc.location_name"
                                        v-text="nextLoc.location_name ? nextLoc.location_name : ' '"></span>
                            </span>

                            <div class="location-nav--icon-wrap">
                                <cmp-icon symbol="arrow-down" size="small" class="location-nav--icon"></cmp-icon>
                            </div>
                        </div>
                    </button>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import { mapGetters } from 'vuex';
    import scrollLockHelperMixin from 'framework/mixins/scroll-lock-helper';


    export default {
        mixins: [
            scrollLockHelperMixin,
        ],
        computed: {
            ...mapGetters(['pageType', 'locationNav']),
            showLocationNav() {
                return this.locationNav && this.pageType === 'page-location';
            },
            prevLoc() {
                return get(this.locationNav, 'prev', {});
            },
            nextLoc() {
                return get(this.locationNav, 'next', {});
            },
        },
        methods: {
            onLocationRequested(location) {
                if (!location) {
                    return;
                }

                this.$router.push(location);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/location-nav/index.vue?4b8b551c